<template>
  <div>
    <v-card max-width="400" class="mx-auto mt-5">
      <v-card-title>
        <h2 class="title">Nuevo usuario</h2>
      </v-card-title>

      <v-card-text>
        <v-form ref="form" v-model="validForm">
          <v-text-field
            autocomplete="new-password"
            autofocus
            v-model="cedula"
            :rules="[rules.required, rules.number]"
            type="text"
            label="Número de cédula"
            prepend-icon="mdi-account-circle"
          />

          <v-text-field
            autocomplete="new-password"
            :value="nombres"
            @input="textToUpper"
            uppercase
            :rules="[rules.required]"
            type="text"
            label="Nombres y Apellidos "
            prepend-icon="mdi-account-circle"
          />

          <v-text-field
            autocomplete="new-password"
            v-model="correo"
            :rules="[rules.required, rules.email]"
            type="text"
            label="Correo electronico"
            prepend-icon="mdi-account-circle"
          />

          <v-text-field
            autocomplete="new-password"
            v-model="celular"
            :rules="[rules.required, rules.celular, rules.number]"
            type="text"
            label="Número de celular"
            prepend-icon="phone"
          />

          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateFormatted"
                :rules="[rules.required]"
                label="Fecha de Nacimiento"
                hint="dia / mes / año"
                persistent-hint
                prepend-icon="event"
                v-bind="attrs"
                @blur="date = parseDate(dateFormatted)"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              ref="picker"
              v-model="date"
              no-title
              @input="menu = false"
              :max="new Date().toISOString().substr(0, 10)"
              min="1930-01-01"
            ></v-date-picker>
          </v-menu>
        </v-form>
        <v-alert type="success" v-if="message">
          {{ message }}
        </v-alert>
        <v-alert type="error" v-if="errorMessage">
          {{ errorMessage }}
        </v-alert>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="primary" outlined @click="$router.push('/login')"
          >Volver</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          :loading="loading"
          :disabled="message != '' || !validForm"
          color="primary"
          @click="registrar"
          >REGISTRARME</v-btn
        >
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import axios from "../axios-auth";
import moment from "moment";
export default {
  data: vm => ({
    correo: "",
    cedula: "",
    celular: "",
    nombres: "",
    date: "",
    dateFormatted: "",
    validForm: false,
    dialog: false,
    snackbar: false,
    message: false,
    errorMessage: "",
    loading: false,
    menu: false,

    rules: {
      required: value => !!value || "Requerido.",
      passwordVerify: value =>
        value == this.password || "Las contraseñas no coinciden.",
      number: value => {
        const pattern = /^[0-9]+$/;
        return pattern.test(value) || "Ingrese solo números";
      },
      counter: value => value.length > 5 || "Ingrese un nombre valido",
      passwordLenght: value =>
        value.length >= 6 || "Debe contener al menos 6 caracteres",
      celular: value => {
        const pattern = /09[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9]/;
        // value.length == 10 || "Ingrese un número valido ej. 09XXXXXX",
        return pattern.test(value) || "Ingrese un número valido ej. 09XXXXXX";
      },
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "email invalido.";
      }
    }
  }),
  mounted() {
    if (this.$route.query.celular) {
      this.celular = this.$route.query.celular;
    }
  },
  methods: {
    textToUpper(val) {
      this.nombres = val.toUpperCase();
    },
    formatDate(date) {
      if (!date) return null;

      if (!moment(date, "YYYY-MM-DD", true).isValid()) {
        this.date = null;
        return null;
      }

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      if (!moment(date, "DD/MM/YYYY", true).isValid()) {
        this.date = null;
        return null;
      }

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    registrar() {
      this.loading = true;
      this.errorMessage = false;
      this.message = false;
      this.dialog = false;
      // this.$store.dispatch("showSnack", "Solicitud recibida!");

      axios
        .post("/singup", {
          cedula: this.cedula,
          celular: this.celular,
          correo: this.correo,
          nombres: this.nombres,
          fechaNacimiento: this.date
        })
        .then(() => {
          this.loading = false;
          this.message =
            "Se envió un enlace a su dirección de correo electrónico para proseguir con el registro";
        })
        .catch(err => {
          this.loading = false;
          if (err.response.data) {
            this.errorMessage = err.response.data;
          } else {
            this.errorMessage = "Error";
          }
          console.log(err);
        });
    }
  },

  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    }
  },

  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date);
    },
    menu(val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = "YEAR"));
    }
  }
};
</script>
